import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material';
import { muiTheme } from 'config/theme';

// REDUX STORE
import { store } from './redux/store';

// ROUTER
import AppRoute from 'routes';

// APP
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const theme = responsiveFontSizes(createTheme(muiTheme));

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App>
        <AppRoute />
      </App>
    </ThemeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
